import { toPairs, fromPairs } from 'lodash';
import queryString from 'querystring';


const baseUrlPath = '\\/inq\\/index.html#\\/';
const optionalQueryParams = '(\\?.*)?$';

const inquiryRootRegexp = new RegExp(baseUrlPath + optionalQueryParams);
const inquiryRootRegexpRAApply = new RegExp(baseUrlPath + 'rocketaccountapply' + optionalQueryParams);
// Want everything after & including first '?' char
const hashSearchParamRegex = /\?.*$/;

export function isLinkOnInquiryRootPage(url) {
  return Boolean(url.match(inquiryRootRegexp)) || Boolean(url.match(inquiryRootRegexpRAApply));
}

function stripQmark(input) {
  if (input[0] === '?') {
    return input.slice(1);
  }
  return input;
}

/** Extracts p&c codes from either the base url or from the hash portion
 * @param {URL} url e.g., window.location
 * @returns {null | {p: string, c: string}} object with P&C codes if valid
 */
export function extractPAndCCodes(url) {
  const searchParams = queryString.parse(stripQmark(url.search));
  const hashMatch = url.hash.match(hashSearchParamRegex);
  const hashSearchParams = queryString.parse(
    hashMatch ? stripQmark(hashMatch[0]) : undefined
  );

  const pAndCObj = fromPairs(
    toPairs(searchParams)
      .concat(toPairs(hashSearchParams))
      .filter((kvPair) => kvPair[0] === 'p' || kvPair[0] === 'c')
  );

  return 'p' in pAndCObj && 'c' in pAndCObj ? pAndCObj : null;
}
